import React from 'react';
import classes from './SkeletonArticlesCard.module.scss';
import Skeleton from '../Skeleton';

export default function SkeletonArticlesCard() {
  return (
    <div className={`${classes.card} skeleton-article-card`}>
      <div className={classes.cardImg}>
        <Skeleton borderRadius='0' width='100%' height='100%' isLight />
      </div>
      <div className={classes.cardDescription}>
        <h4 className={classes.cardTitle}>
          <Skeleton borderRadius='5px' width='100%' height={25} isLight={false} />
        </h4>
        <div className={classes.cardText1}>
          <Skeleton borderRadius='5px' width='100%' height={15} isLight={false} />
        </div>
        <div className={classes.cardText2}>
          <Skeleton borderRadius='5px' width='100%' height={15} isLight={false} />
        </div>
        <div className={classes.cardText1}>
          <Skeleton borderRadius='5px' width='100%' height={15} isLight={false} />
        </div>
        <div className={classes.cardText3}>
          <Skeleton borderRadius='5px' width='100%' height={15} isLight={false} />
        </div>
        <div className={classes.cardDate}>
          <Skeleton borderRadius='5px' width='32%' height={15} isLight={false} />
        </div>
      </div>
    </div>
  );
}
